/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _range = _interopDefault(require('lodash/fp/range'));
var __ol = _interopDefault(require('openlayers'));
var core = require('../core');

var WMTSSource = __ol.source.WMTS;
var WMTSTileGrid = __ol.tilegrid.WMTS;
var props = {
  dimensions: Object,
  format: {
    type: String,
    default: core.WMTS_FORMAT
  },
  layerName: {
    type: String,
    required: true
  },
  matrixSet: {
    type: String,
    required: true
  },
  requestEncoding: {
    type: String,
    default: core.WMTS_REQUEST_ENCODING
  },
  styleName: {
    type: String,
    required: true
  },
  version: {
    type: String,
    default: core.WMTS_VERSION
  },
  url: {
    type: String,
    required: true
  }
};

var methods = {
  /**
   * @returns {ol.source.WMTS}
   * @protected
   */
  createSource: function createSource() {
    return new WMTSSource({
      attributions: this.attributions,
      cacheSize: this.cacheSize,
      crossOrigin: this.crossOrigin,
      dimensions: this.dimensions,
      format: this.format,
      layer: this.layerName,
      logo: this.logo,
      matrixSet: this.matrixSet,
      projection: this.projection,
      reprojectionErrorThreshold: this.reprojectionErrorThreshold,
      requestEncoding: this.requestEncoding,
      tileGrid: this._tileGrid,
      tilePixelRatio: this.tilePixelRatio,
      style: this.styleName,
      version: this.version,
      url: this.urlTmpl,
      wrapX: this.wrapX
    });
  },

  /**
   * @return {ol.tilegrid.WMTS}
   * @protected
   */
  createTileGrid: function createTileGrid() {
    core.assert.hasView(this);

    var extent = core.extentHelper.fromProjection(this.$view.getProjection());
    var resolutions = core.tileGridHelper.resolutionsFromExtent(extent, this.maxZoom, this.tileSize);

    return new WMTSTileGrid({
      extent: extent,
      resolutions: resolutions,
      tileSize: this.tileSize,
      minZoom: this.minZoom,
      matrixIds: _range(this.minZoom, resolutions.length)
    });
  }
};

var Source = {
  name: 'vl-source-wmts',
  mixins: [core.tileSource],
  props: props,
  methods: methods
};

var index = {
  Source: Source,
  install: function install(Vue) {
    Vue.component(Source.name, Source);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/wmts-source/index.js
// module id = 1205
// module chunks = 1